import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-restriction-modal',
  templateUrl: './restriction-modal.component.html',
  styleUrls: ['./restriction-modal.component.scss']
})
export class RestrictionModalComponent implements OnInit {

  constructor(
    public bsModalRef: BsModalRef,
    public options: ModalOptions,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.bsModalRef.hide();
    
  }
  
  goToEnquiry() {
    this.bsModalRef.hide();
    this.router.navigateByUrl('/assisted-booking')
  }

}
